import * as pdfjsLib from 'pdfjs-dist';

// Configure worker - try public folder first, fallback to CDN
// Option 1: Use worker from public folder (recommended for Create React App)
// Copy pdf.worker.min.js from node_modules/pdfjs-dist/build/pdf.worker.min.js to public/pdf.worker.min.js
const workerSrcFromPublic = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

// Option 2: Fallback to jsDelivr CDN (more reliable than cdnjs)
const workerSrcFromCDN = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`;

// Use CDN for now (will work immediately)
// TODO: Copy worker file to public folder and use workerSrcFromPublic instead
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrcFromCDN;

/**
 * Extract text content from a PDF file using pdfjs-dist
 * @param {File} file - PDF file to extract text from
 * @returns {Promise<{text: string, pages: number}>} - Extracted text and page count
 */
export async function extractTextFromPDF(file) {
  try {
    // Read file as ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();
    
    // Load the PDF document using pdfjs-dist
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;
    const numPages = pdf.numPages;
    
    // Extract text from each page
    const textParts = [];
    
    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      
      // Combine all text items on the page
      const pageText = textContent.items
        .map(item => item.str)
        .join(' ');
      
      textParts.push(pageText);
    }
    
    const fullText = textParts.join('\n\n').trim();
    
    if (!fullText || fullText.length === 0) {
      throw new Error('Could not extract text from PDF. The file may be empty or contain only images.');
    }
    
    return {
      text: fullText,
      pages: numPages
    };
  } catch (error) {
    console.error('PDF extraction error:', error);
    
    // Provide user-friendly error messages
    if (error.message && (error.message.includes('Invalid PDF') || error.message.includes('corrupt'))) {
      throw new Error('Invalid PDF file. Please upload a valid PDF document.');
    }
    if (error.message && (error.message.includes('Password') || error.message.includes('encrypted'))) {
      throw new Error('Password-protected PDFs are not supported.');
    }
    
    throw new Error(error.message || 'Failed to process PDF');
  }
}
